import React from "react"

import Heading from "../Heading/Heading"

const Objective = () => {
	return (
		<div className='container-lg'>
			<div className='our-mission row justify-content-center align-items-center py-5'>
				<Heading main='objective' />
				<div className='inner-content text-dark h5 font-weight-light '>
					<p className='mb-0'>
						Our mission is to provide products made by the best of ethically sourced ingredients that are
						natural, safe, and skin-friendly, packed in handmade paper packages in lieu of plastics. We
						emphasize quality and authenticity. All our products are designed and manufactured in India, by
						a community of underprivileged women in Gurugram who are greatly provided with employment
						through this endeavour.
					</p>
				</div>
			</div>
		</div>
	)
}

export default Objective
